const config = {
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_V2: process.env.REACT_APP_API_URL_V2,
  API_URL_V3: process.env.REACT_APP_API_URL_V3,
};
export default config;
